/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import { cssVar } from '../../../constants';
var baseStyles = css({
  display: 'flex',
  height: '16px',
  margin: 0,
  padding: 0,
  position: 'absolute',
  right: 0,
  alignItems: 'center',
  justifyContent: 'center',
  alignSelf: 'center',
  appearance: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: "var(".concat(cssVar.borderRadius, ")"),
  // Once legacy theming is dropped, this can be changed to 'inherit'
  color: "var(".concat(cssVar.color.removeButton.default, ")"),
  cursor: 'pointer',
  pointerEvents: 'auto',
  '&::-moz-focus-inner': {
    margin: 0,
    padding: 0,
    border: 0
  },
  ':hover': {
    // Once legacy theming is dropped, this can be changed to 'cssVar.color.text.default'
    color: "var(".concat(cssVar.color.removeButton.hover, ")")
  }
});
var focusRingStyles = css({
  '&:focus': {
    boxShadow: "0 0 0 2px var(".concat(cssVar.color.focusRing, ") inset"),
    outline: 'none'
  }
});

var RemoveButton = function RemoveButton(_ref) {
  var ariaLabel = _ref['aria-label'],
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onKeyPress = _ref.onKeyPress,
      onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut,
      testId = _ref.testId;
  return jsx("button", {
    css: [baseStyles, focusRingStyles],
    tabIndex: 0,
    "aria-label": ariaLabel,
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyPress: onKeyPress,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    type: "button",
    "data-testid": testId
  }, jsx(EditorCloseIcon, {
    label: "close tag",
    size: "small"
  }));
};

export default RemoveButton;